import styled from 'styled-components';

export const WrapperDiv = styled.div`
  position: fixed;
  bottom: 0;
  right: 10rem;
  display: flex;
  justify-content: flex-end;
  z-index: 99;
`;

export const InnerWrapper = styled.div`
  width: 415px;
  max-height: 346px;
  min-height: 152px;
  border-radius: 1rem;
  box-shadow: 0 4px 8px 5px rgba(138, 107, 118, 0.08);
  border: solid 0.5px #bababa;
  background-color: #000000;
  margin-bottom: 4rem;
  overflow: auto;
`;

export const InnerCollapsedWrapper = styled.div`
  width: 415px;
  border-radius: 1rem 1rem 0rem 0rem;
  box-shadow: 0 4px 8px 5px rgba(138, 107, 118, 0.08);
  border: solid 0.5px #bababa;
  background-color: #000000;
  overflow: auto;
`;

export const HeaderText = styled.div`
  padding: 1.5rem;
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
`;

export const HeaderSubText = styled.span(
  props => `
    font-size: ${props.theme.font.base};
    font-weight: normal;
    padding-left: ${props.theme.spacing.small.s5};
  `
)

export const CloseIconWrap = styled.span`
  float: right;
  text-align: center;
`;

export const ResetText = styled.span`
  padding: 1.5rem;
  width: 100%;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
`;

export const CardBlock = styled.div`
  display: flex;
  align-items: center;
  padding: 0rem 2rem 2rem 2rem;
`;

export const CardList = styled.div`
  overflow-y: auto;
`;

export const ShareCheck = styled.input.attrs({type: 'checkbox'})`
  display: inline-flex;
  margin-right: 0.5rem;
`;

export const ShareImage = styled.img`
  width: 74px;
  height: 59px;
  border-radius: 2px;
`;

export const ShareInfo = styled.div`
  padding: 0rem 1rem;
  color: #ffffff;
  width: 75%;
`;

export const StarRating = styled.div`
`;
export const HotelName = styled.div`
  font-size: 14px;
  font-weight: bold;
`;

export const Location = styled.div`
  display: flex;
`;

export const TextInput = styled.input`
  display: flex;
  width: 100%;
  background: #000000;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 1px solid rgba(255,255,255,0.5);
  color: #ffffff;
  font-style: italic;
  &:focus {
    outline: none;
  }
`;

export const Footer = styled.div`
  width: 415px;
  box-shadow: 0 4px 8px 5px rgba(138, 107, 118, 0.08);
  border: solid 0.5px #bababa;
  border-top: 0;
  height: 49px;
  position: absolute;
  bottom: 0;
  background-color: #4a4a4a;
  padding: 1.5rem;
  text-align: center;
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
`;

export const ModalHeader = styled.h3`
  font-size: 2.2rem;
  font-weight: bold;
  padding: 2rem;
  border-bottom: .1rem solid #bababa;
  color: #000000;
`;

export const ModalFooter = styled.div`
  padding: 1.5rem 2rem 1rem 2rem;
  border-top: .1rem solid #bababa;
  color: #000000;
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  border-radius: 0rem 0rem 0.8rem 0.8rem;
  min-height: 6rem;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ModalButton = styled.button(
  props => `
    background-image: ${props.disabled ? 'linear-gradient(to left, #f4f4f4, #ececec);' : 'linear-gradient(96deg, #53b2fe, #065af3)'};
    box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
    color: white;
    flex-shrink: 0;
    text-transform: uppercase;
    font-weight: 900;
    padding: 0.9rem 2rem;
    cursor: ${props.disabled ? 'default' : 'pointer'};
    pointer-events: ${props.disabled ? 'none' : ''};
    border: 0;
    outline: 0;
    align-items: center;
    border-radius: 3rem;
    float: right;
  `
);

export const ModalContent = styled.div(
 props => `width: 100%;
  padding: ${props.minPadding || '2rem'};
  min-height: ${props.minHeight || '47rem'};
  display: flex;
  justify-content: center;
  align-items: flex-start;
`);

export const AcknowledgeText = styled.div(
  props => `
  font-size: 1.6rem;
  display: flex;
  justify-content: center;
  padding: ${props.minPadding || '1rem'};
  margin-bottom: ${props.minMargin || '0'};
`);

export const ModalContentLoader = styled.div`
  width: 100%;
  padding: 2rem;
  min-height: 40rem;
  display: flex;
  align-items: center;
`;

export const AcknowledgeContainer = styled(ModalContent)`
  min-height  ${({ minHeight }) => (minHeight ? minHeight : "47rem")};
  padding: ${({ minPadding }) => (minPadding ? minPadding : "2rem")};

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ErrorText = styled.div(
  props => `
    display: flex;
    align-items: center;
    font-size: ${props.fs || '1.4rem'};
    color: #eb2026;
    margin: ${props.margin || '0'};
  `
);

export const ModalContainer = styled.div`
  width: 100%;
  /* max-height: 550px; */
  display: block;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

export const UserInput = styled.div`
  display: flex;
  flex-direction: column;
  float: right;
`;

export const InputBox = styled.input`
  padding: 0.7rem;
  margin: 0 2rem;
  border-radius: 0.4rem;
  border: solid 1px rgba(0,0,0,0.25);
  height:4rem;
  width: 26rem;

`;

export const UserInfo = styled.p`
  margin: 0 2rem;
  color: #979797;
  padding-top: .3rem;
  span {
    color: #000000;
    padding: 0 0.5rem;
    font-weight: bold;
  }
`;
